<template>
  <v-card class="elevation-12" loading="true">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Вход</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="login()">
      <v-card-text>
        <v-text-field
          label="Почта"
          name="login"
          prepend-icon="mdi-account"
          type="text"
          required
          v-model="email"
        ></v-text-field>

        <v-text-field
          id="password"
          label="Пароль"
          name="password"
          prepend-icon="mdi-lock"
          type="password"
          required
          v-model="password"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" type="submit">
          Войти
          <v-progress-circular
            v-if="loading"
            class="ml-1"
            indeterminate
            size="18"
          ></v-progress-circular>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('restore-password')">Сбросить пароль</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import store from "../store";
import axios from "axios";
import api from "../api";

export default {
  name: "login-form",
  data() {
    return {
      email: "",
      password: "",
      loading: false
    };
  },
  methods: {
    login: function() {
      this.loading = true;
      axios
        .post(api.login, {
          email: this.email,
          password: this.password
        })
        .then(response => {
          // сохраняем информацию о пользователе в стор
          store.currentUser = response.data;

          // токен прпоисываем в лс и ахиос для дальнейших запросов
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user-id", response.data.id);
          axios.defaults.headers.common["X-Api-Key"] = response.data.token;

          // перенаправляем на главную страницу сервиса
          this.$router.push("/");
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
